import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import Switcher from '../../Switcher/Switcher';

import styles from './DateFilterSwitcher.module.scss';

const DateFilterSwitcher = ({ isMonthsFilter, onClick }) => (
  <Switcher
    className={styles['date-filter-switcher']}
    onClickLeft={onClick}
    onClickRight={onClick}
    isPositionRight={isMonthsFilter}
    renderLeftIcon={() => (
      <span className={styles['date-filter-switcher__item']}>
        {trans('search.exposedfilters.dates.switcher.dates')}
      </span>
    )}
    renderRightIcon={() => (
      <span className={styles['date-filter-switcher__item']}>
        {trans('search.exposedfilters.dates.switcher.months')}
      </span>
    )}
    dataTest="date-filter-switcher"
    colorSchema="date-filter"
  />
);

DateFilterSwitcher.propTypes = {
  isMonthsFilter: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default DateFilterSwitcher;
